import { number, shape, string } from 'prop-types'

export const VariantOfferType = shape({
  offerType: string,
  offerPrice: shape({
    additionalInformation: shape({
      discount: shape({
        percentage: number,
      }),
    }),
    price: number,
    currency: string,
  }),
  strikeThroughOfferPrice: shape({
    price: number,
    currency: string,
  }),
})
